import React, { Component } from 'react';
import { Icons } from '../../utilities';
import * as Constants from '../../utilities/constants/Constants';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { requestSampleIsClicked } from '../../redux/fabricCanvasActions';
import * as pixelationHandler from '../../redux/actions/pixelationHandler';
import '../../Containers/Body/DesignComponent/FabricCanvas/FabricCanvas.scss';
import './ZoomWarningWindow.scss';
import { string } from '../../localization';
import MediaQuery from 'react-responsive';

class ZoomWarningView extends Component {
  state = {
    dpiValue: 0,
    minimumViewingDistanceForWarning: 0,
    imagePixels: {}
  };

  componentDidMount() {
    const { dispatchers, activeObject } = this.props;

    if (activeObject) {
      const value = dispatchers.pixelationHandler.currentDisplayDpi(
        activeObject
      );
      const recommendedMinimumDistance = dispatchers.pixelationHandler
        .minimumViewingDistanceForWarningRemovalInCurrentUnitSystem(
          activeObject
        )
        .toFixed(2);
      const pixels = dispatchers.pixelationHandler.validImageDimensionsInPixels(
        activeObject.placing
      );

      this.setState({
        dpiValue: value,
        minimumViewingDistanceForWarning: recommendedMinimumDistance,
        imagePixels: pixels
      });
    }
  }

  render() {
    const {
      unitSystem,
      showPixelationWindowDialogue,
      minimumViewingDistance,
      viewOnlyPreviewMode,
      dispatchers,
      supportsSample
    } = this.props;

    const {
      dpiValue,
      minimumViewingDistanceForWarning,
      imagePixels
    } = this.state;
    const minimumViewingDistancePerUnitSystem =
      unitSystem === Constants.METRIC_KEY
        ? (minimumViewingDistance * 2.54).toFixed(2)
        : minimumViewingDistance;
    const unit =
      unitSystem === Constants.METRIC_KEY
        ? string.CM_UNIT_KEY
        : string.LENGTH_STRING_IN_INCHES_KEY;
    const unitAbrv =
      unitSystem === Constants.METRIC_KEY
        ? string.CM_KEY
        : string.INCHES_UNIT_STRING_KEY;

    return (
      <div>
        <Modal
          className='zoom-modal'
          isOpen={showPixelationWindowDialogue}
          // toggle={this.toggleScaleModal}
          contentClassName='border-0 bg-transparent'
          backdrop={false}
          centered
        >
          <ModalBody className='rounded-0'>
            <ModalHeader
              className='p-0 pb-2 border-0'
              // toggle={this.toggleScaleModal}
              close={
                <button
                  type='button'
                  className='close pt-0 pb-0'
                  onClick={() =>
                    dispatchers.pixelationHandler.setShowPixelationWindowDialogue(
                      false
                    )
                  }
                >
                  <img
                    className='close-icon'
                    src={Icons.closeDefault}
                    alt='close'
                  />
                </button>
              }
            >
              <button
                type='button'
                style={{ border: 'none', background: 'none', outline: 'none' }}
                onClick={() =>
                  dispatchers.pixelationHandler.setShowPixelationWindowDialogue(
                    true
                  )
                }
              >
                <img
                  style={{
                    width: 30,
                    height: 30,
                    marginRight: 10,
                    lineHeight: 30
                  }}
                  src={Icons.pixelation_warning_icon_black}
                  alt='pixelation_warning_icon'
                />
              </button>
              <span className='warning-text'>{string.WARNING_KEY}</span>
            </ModalHeader>
            <p
              className='pixelation-warning-texts'
              style={{
                fontSize: '13px',
                color: 'rgb(74, 74, 74)',
                marginTop: '20px'
              }}
            >
              {string.formatString(
                string.ZOOM_WARNING_PIXELATED_TEXT,
                minimumViewingDistancePerUnitSystem,
                unit,
                dpiValue
              )}
            </p>
            <p
              className='pixelation-warning-texts'
              style={{
                fontSize: '13px',
                color: 'rgb(192,192,192)',
                marginTop: '20px'
              }}
            >
              {string.formatString(
                string.ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT,
                minimumViewingDistanceForWarning,
                unitAbrv
              )}
            </p>

            <p
              className='pixelation-warning-texts'
              style={{
                fontSize: '13px',
                color: 'rgb(192,192,192)'
              }}
            >
              {imagePixels.width
                ? string.formatString(
                    string.ZOOM_WARNING_VALID_IMAGE_TEXT,
                    imagePixels.width,
                    imagePixels.height
                  )
                : null}
            </p>
            <p
              className='pixelation-warning-texts'
              style={{
                fontSize: '13px',
                color: 'rgb(192,192,192)'
              }}
            >
              {string.TARGET_VIEWING_HINT}
            </p>
            <MediaQuery query='(max-width: 767px)'>
              {supportsSample && !viewOnlyPreviewMode ? (
                <button
                  type='button'
                  className='requestSample'
                  onClick={dispatchers.requestSampleIsClicked}
                >
                  <text style={{ textDecorationLine: 'underline' }}>
                    {string.REQUEST_SAMPLE_KEY}
                  </text>
                </button>
              ) : null}
            </MediaQuery>

            <button
              type='button'
              className='ok-button'
              style={{
                width: '150px',
                height: '36px',
                float: 'right',
                marginRight: '10px',
                backgroundColor: 'rgb(10, 124, 193)',
                border: 'navajowhite',
                color: 'white'
              }}
              onClick={() =>
                dispatchers.pixelationHandler.setShowPixelationWindowDialogue(
                  false
                )
              }
            >
              {string.OK_KEY}
            </button>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    showPixelationWarningField: state.fabricCanvas.showPixelationWarningField,
    showPixelationWindowDialogue:
      state.fabricCanvas.showPixelationWindowDialogue,
    minimumViewingDistance: state.finalCheck.project.targetViewingDistance,
    unitSystem: state.home.unitSystem,
    activeObject: state.fabricCanvas.activeObject,
    viewOnlyPreviewMode: state.modal.envData.view_only_preview_mode,
    supportsSample: state.modal.storeData.supportsSample
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      requestSampleIsClicked: bindActionCreators(
        requestSampleIsClicked,
        dispatch
      ),
      pixelationHandler: bindActionCreators(pixelationHandler, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ZoomWarningView);
